/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ShipmentGroupSolutionSegmentDtoModel } from './shipment-group-solution-segment-dto.model';
import { ShipmentDraftDTO } from '../index';

export class ShipmentGroupSolutionDtoModel extends JSONable {

  uuid: string | undefined = undefined;

  shipmentGroupSolutionSegmentDtos: ShipmentGroupSolutionSegmentDtoModel[] = [];

  remainingShipmentDraftDTOs: ShipmentDraftDTO[] | undefined = undefined;

  solutionComplete: boolean | undefined = undefined;

  isLockedIn: boolean | null | undefined = undefined;

  shipmentGroupUuid: string | undefined = undefined;

  canBeEdited: boolean | undefined = undefined;

  forOrder: boolean | undefined = undefined;

  constructor() {
    super();
    this.uuid = undefined;
    this.shipmentGroupSolutionSegmentDtos = [];
    this.remainingShipmentDraftDTOs = [];
    this.solutionComplete = undefined;
    this.shipmentGroupUuid = undefined;
    this.canBeEdited = undefined;
    this.forOrder = false;
  }

  static createForm(): FormGroup {
    return new FormGroup({
      uuid: new FormControl(null),
      shipmentGroupSolutionSegmentDtos: new FormArray([]),
      remainingShipmentDraftDTOs: new FormArray([]),
      solutionComplete: new FormControl(),
      isSolutionComplete: new FormControl(),
      shipmentGroupUuid: new FormControl(),
      canBeEdited: new FormControl(),
    });
  }

}
